
const AUTH_KEY = "auth";

export const getAuth = () => {
  try {
    return JSON.parse(sessionStorage.getItem(AUTH_KEY) || "null");
  } catch {
    return null;
  }
};

export const setAuth = (authData) => {
  sessionStorage.setItem(AUTH_KEY, JSON.stringify(authData));
};

export const clearAuth = () => {
  sessionStorage.removeItem(AUTH_KEY);
};